import axios from 'axios'
import {
  GlobalAcademicTermsArraySchema,
  GlobalAcademicTermsArray,
  ProgramTermsArraySchema,
} from './schema'
export type UpdateProgramAcademicTermPayload = {
  programId: number
  purseId: number
  academicTermId: number
  startDate: string
  endDate: string
  schoolYear: string
}

export const academicTermsApi = {
  getProgramAcademicTerms: async (programId: number, purseId: number) => {
    const response = await axios.get(
      `/programs/${programId}/purses/${purseId}/settings/academic_terms`
    )
    return ProgramTermsArraySchema.parse(response.data)
  },

  getGlobalAcademicTerms: async (): Promise<GlobalAcademicTermsArray> => {
    const response = await axios.get('/academic_term_types')
    return GlobalAcademicTermsArraySchema.parse(response.data)
  },

  updateProgramPurseAcademicTerm: async ({
    programId,
    purseId,
    academicTermId,
    startDate,
    endDate,
    schoolYear,
  }: UpdateProgramAcademicTermPayload) => {
    const response = await axios.put(
      `/programs/${programId}/purses/${purseId}/settings/academic_terms/${academicTermId}`,
      {
        awarding_period_start_date: startDate,
        awarding_period_end_date: endDate,
        school_year: schoolYear,
      }
    )
    return response.data
  },
}
